import React, {
  useEffect,
  useState
} from 'react';
import {
  Chart,
  Series,
  CommonSeriesSettings,
  Legend,
  Export
} from 'devextreme-react/chart';

const Details = ({
  metricReducer: { listDetailed },
  metricUserActivityDetailed,
  data
}) => {
  const [dataSource, setDataSource] = useState([]);
  const [nameSeries, setNameSeries] = useState([]);

  useEffect(() => {
    metricUserActivityDetailed(data);
  }, [data, metricUserActivityDetailed]);
  useEffect(() => {
    if (listDetailed && listDetailed.length) {
      const temp = [];
      const tempName = new Set();

      listDetailed.forEach((item) => {
        tempName.add(item.plant);
        temp[item.userName] = {
          ...temp[item.userName],
          [item.plant]: item.amount
        };
      });

      const tempDop = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const i of Object.keys(temp)) {
        tempDop.push({
          state: i,
          ...temp[i]
        });
      }

      setDataSource(tempDop);
      setNameSeries(Array.from(tempName));
    }
  }, [listDetailed]);

  return (
    <div>
      <Chart
        id="chart"
        palette="Soft"
        title={data.description}
        dataSource={dataSource}
      >
        <CommonSeriesSettings
          argumentField="state"
          type="bar"
          ignoreEmptyPoints
        />
        {
          nameSeries.map((item) => (
            <Series key={item} valueField={item} name={item} />
          ))
        }
        <Legend verticalAlignment="bottom" horizontalAlignment="center" />
        <Export enabled />
      </Chart>
    </div>
  );
};

export default Details;
